import { FinanceAccountListContainer } from '../../../containers';

export const FinanceAccountList = () => {
  return <FinanceAccountListContainer />;
};
